var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('Header',{attrs:{"currentRouteName":this.$router.currentRoute.name}}),_c('main',[_c('router-view')],1),(_vm.displayFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }